export default __webpack_public_path__ + "8476688d1025533494925bc8bf6285cb.svg";